import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Button,
  IconButton
} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const RoundController = () => {
  const {
    pairingEvent,
    setPairingEvent,
    roundInfo,
    setRoundInfo,
    displayData,
    setDisplayData,
  } = React.useContext(EventContext);
  // const [paused, setPaused] = React.useState(false);
  const [percentageComplete, setPercComplete] = React.useState(0);
  const [roundComplete, setRoundComplete] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  // const [displayData, setDisplayData] = React.useState({seconds:0, display:"", percentage:0})

  React.useEffect(() => {
    if (
      pairingEvent?.event?.status === "active" &&
      (!roundInfo.timeLeft || roundInfo.timeLeft === 0)
    ) {
      setRoundComplete(true);
    } else {
      setRoundComplete(false);
    }
  }, [pairingEvent, roundInfo]);

  React.useEffect(() => {
    // if (Object.keys(roundInfo).length > 0) {
    //   setPaused(roundInfo.paused);
    // }
    let val;
    if (roundInfo.timeLeft && pairingEvent?.roundDuration) {
      val = (roundInfo.timeLeft / (pairingEvent.roundDuration * 60)) * 100;
    } else {
      val = 0;
    }
    setPercComplete(val);
  }, [roundInfo]);

  const handleRoundChange = async (action) => {
    const body = {
      pairingEventId: pairingEvent._id,
      action,
    };
    let result = await request("pairingevent/changeround", "post", body);
    if (!result.success) {
      alert(result.error);
      return;
    }
    setPairingEvent(result.pairingEvent);
  };

  if (pairingEvent?.pairingEventType === "mixer") {
    return null
  }

  return (
    <Paper height={3} style={{ padding: 10 }}>
      <Grid
        container
        spacing={1}
        justifyContent="space-around"
        alignItems="center"
        style={{padding: 10}}
      >
        <Grid item xs={12}>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Typography variant="h6">Round</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction="row" spacing={3} justifyContent="center" alignItems="center">
            <Grid item>
              <IconButton
                sx={{fontSize: 40}}
                onClick={() => handleRoundChange("previous")}
              >
                <RemoveCircleOutlineIcon fontSize="inherit"/>
              </IconButton>
            </Grid>
            <Grid item>
              <Typography variant="h6" style={{fontWeight: 'bold', fontSize: 30}}>
                {pairingEvent ? pairingEvent.currentRound : ""}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                sx={{fontSize: 40}}
                onClick={() => handleRoundChange("next")}
              >
                <AddCircleOutlineIcon fontSize="inherit"/>
              </IconButton>
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid
          item
          xs={5}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => handleRoundChange("next")}
              >
                Next Round
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => handleRoundChange("previous")}
              >
                Prev Round
              </Button>
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </Paper>
  );
};

export default RoundController;
